export enum MessageTargetType {
  Log = 'log', // log to server
  Console = 'console', // log into the browser console
  Popup = 'popup', // show in popup
}
